import { SingleLayerMasterPanelHeader } from "azure-devops-ui/Components/SingleLayerMasterPanel/SingleLayerMasterPanel";
import { ObservableValue } from "azure-devops-ui/Core/Observable";
import { IListItemDetails, List, ListItem, ListSelection } from "azure-devops-ui/List";
import { SingleLayerMasterPanel } from "azure-devops-ui/MasterDetails";
import { bindSelectionToObservable } from "azure-devops-ui/MasterDetailsContext";
import { Observer } from "azure-devops-ui/Observer";
import { ArrayItemProvider, IItemProvider } from "azure-devops-ui/Utilities/Provider";
import { Page } from "azure-devops-ui/Page";
import { Tooltip } from "azure-devops-ui/TooltipEx";
import * as React from "react";
import "./MasterDetail.Example.css";

const sampleDate: string[] = [
    "Added GitHub aliases",
    "Remove reference to Design System components",
    "Using new design / pattern / components",
    "Fixing bug with spacing",
    "Added some new components",
    "Setting up theme variables",
    "Updating Button focus behavior",
];

const SingleLayerMasterPanelExample: React.FunctionComponent<{}> = (props) => {
    const [selection] = React.useState(new ListSelection({ selectOnFocus: false }));
    const [itemProvider] = React.useState(new ArrayItemProvider(sampleDate));
    const [selectedItemObservable] = React.useState(new ObservableValue<string>(sampleDate[0]));

    React.useEffect(() => {
        bindSelectionToObservable(selection, itemProvider, selectedItemObservable);
    });

    return (
        <div className="master-example-scroll-container flex-row">
            <SingleLayerMasterPanel
                className="master-example-panel show-on-small-screens"
                renderHeader={renderHeader}
                renderContent={() => renderContent(selection, itemProvider)}
            />

            <Observer selectedItem={selectedItemObservable}>
                {(observerProps: { selectedItem: string }) => (
                    <Page className="flex-grow single-layer-details flex-noshrink">
                        {observerProps.selectedItem && (
                            <Tooltip text={observerProps.selectedItem} overflowOnly={true}>
                                <span className="single-layer-details-contents">
                                    {observerProps.selectedItem}
                                </span>
                            </Tooltip>
                        )}
                    </Page>
                )}
            </Observer>
        </div>
    );
};

const renderHeader = () => {
    return <SingleLayerMasterPanelHeader title="Commits" />;
};

const renderContent = (selection: ListSelection, itemProvider: IItemProvider<string>) => {
    return (
        <List
            ariaLabel={"Commits Master Table"}
            itemProvider={itemProvider}
            selection={selection}
            renderRow={renderListItem}
            width="100%"
            singleClickActivation={true}
        />
    );
};

const renderListItem = (
    index: number,
    item: string,
    details: IListItemDetails<string>,
    key?: string
): JSX.Element => {
    return (
        <ListItem
            className="master-example-row"
            key={key || "list-item" + index}
            index={index}
            details={details}
        >
            <div className="master-example-row-content show-on-small-screens flex-row flex-center h-scroll-hidden">
                <Tooltip overflowOnly={true}>
                    <div className="primary-text">{item}</div>
                </Tooltip>
            </div>
        </ListItem>
    );
};

export default SingleLayerMasterPanelExample;
